import type { TextareaHTMLAttributes } from 'react';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string | null;
  hint?: string;
  showCounter?: boolean;
}

export default function Textarea({
  label,
  error,
  hint,
  showCounter = false,
  id,
  className = '',
  rows = 3,
  maxLength,
  value,
  ...rest
}: TextareaProps) {
  const areaId = id || rest.name || label?.replace(/\s+/g, '-').toLowerCase();
  const currentLength = typeof value === 'string' ? value.length : 0;

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={areaId}
          className="mb-1.5 block text-xs font-semibold text-foreground-700 font-label"
        >
          {label}
        </label>
      )}
      <textarea
        id={areaId}
        rows={rows}
        maxLength={maxLength}
        value={value}
        className={[
          'w-full resize-y rounded-md border bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400',
          'transition-colors duration-200 focus:outline-none focus:ring-2',
          error
            ? 'border-red-400 focus:border-red-500 focus:ring-red-200'
            : 'border-background-300 focus:border-primary-400 focus:ring-primary-200',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        {...rest}
      />
      <div className="mt-1.5 flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          {error ? (
            <p className="flex items-center gap-1 text-xs text-red-600">
              <i className="ri-error-warning-line text-sm"></i>
              {error}
            </p>
          ) : (
            hint && <p className="text-xs text-foreground-500">{hint}</p>
          )}
        </div>
        {showCounter && maxLength && (
          <span className="shrink-0 text-xs text-foreground-400">
            {currentLength}/{maxLength}
          </span>
        )}
      </div>
    </div>
  );
}